import { BaseResponseMapper } from './Base'
import { Pagination } from '@/domain/entities/Pagination'
import { Bulletin, BulletinData } from '@/domain/entities/Bulletin'
import { AxiosResponse } from 'axios'

export class BulletinDataMapper extends BaseResponseMapper {
  public convertFromApi(result: AxiosResponse<any>): Bulletin {
    const { data } = result
    return new Bulletin(
      data.success,
      data.message,
      new Pagination(
        data.pagination.current_page,
        data.pagination.page_count,
        data.pagination.page_size,
        data.pagination.row_count,
        data.pagination.first_row_on_page,
        data.pagination.last_row_on_page
      ),
      data.data.map(
        (val) =>
          new BulletinData(
            val.id,
            val.file.code,
            val.title,
            val.is_active,
            val.is_recommended,
            val.owner,
            val.file,
            val.image_thumbnail,
            val.created_at,
            val.updated_at,
            val.expireddate
          )
      )
    )
  }
}
